import React, { useState, useEffect, useRef } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import style from './SignUp.module.css';
import URL from '../../../../constants/url';
import { useLocation, useNavigate } from 'react-router-dom';
import ToastPopup from '../../../../components/comm/ToastPopup';
import { getIsDpAuthUserId, setDpAuthSignup } from '../../../../assets/js/comm';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import MSG from '../../../../constants/message';
import ConfirmBox from '../../../../components/box/ConfirmBox';


const SignUp = () => {

    const location = useLocation();
    // state : { urgpCd: urgpCd, usrNm: name, mblNo: phone, brthdy: birth, gendr: genderCode, usrSeCd: "11", statCd: "1", allTrmsAgreDt: 1721856000 }
    const { state } = location;

    const navigate = useNavigate();
    const [step, setStep] = useState(1);

    //console.log( " =========> SignUp state : ", state );

    // modal
    const [isOpen, setIsOpen] = useState(false);

    // toast
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    //const [ userId, setUserId ] = useState(''); // 아이디는 상호비교가 없어 렌더링이 걸릴 필요가 없음..
    const userIdRef = useRef('');
    const [ pswd, setPswd ] = useState('');
    const [ rePswd, setRePswd ] = useState('');
    // password view
    const [pwView, setPwView] = useState(false);
    const [rePwView, setRePwView] = useState(false);

    // password line
    const [pwLineStatus, setPwLineStatus] = useState("");      // 비밀번호 line
    const [rePwLineStatus, setRePwLineStatus] = useState("");  // 재입력 line


    const [ idRules, setIdRules ] = useState( {
        lengthAt: false,
        letterNumberAt: false
    });
    const [ pwRules, setPwRules ] = useState({
        lengthAt: false,
        numberAt: false,
        letterAt: false,
        // letterLowerAt: false,
        // letterUpperAt: false,
        specialAt: false,
    });


    // 비밀번호 line 상태 계산
    useEffect(() => {
        if (!pswd) {
            setPwLineStatus(""); // 비어있으면 표시 없음
        } else {
            setPwLineStatus(Object.values(pwRules).every(Boolean) ? "off" : "on");
        }
    }, [pswd, pwRules]);

    // 재입력 비밀번호 line 상태 계산
    useEffect(() => {
        if (!rePswd) {
            setRePwLineStatus(""); // 비어있으면 표시 없음
        } else {
            setRePwLineStatus(
                pswd === rePswd ? "off" : "on"
            );
        }
    }, [pswd, rePswd, pwRules]);

    // feedback
    const [ signUsrInfo, setSignUsrInfo ] = useState({});

    const handlePwView = () => {
        setPwView(!pwView);
    };
    const handleRePwView = () => {
        setRePwView(!rePwView);
    };

    const handleOnConfirm = () => {
        //console.log( " ==========> userIdRef.current.length : ", userIdRef.current.value.length );
        if( !idRules.lengthAt || !idRules.letterNumberAt ) {
            setToastMessage("아이디 형식이 올바르지 않습니다.");
            setToast(true);
        } else if( idRules.lengthAt && idRules.letterNumberAt ) {
            getIsDpAuthUserId(userIdRef.current.value)
                .then( (res) => {
                    //console.log( "  ====> handleOnConfirm getIsDpAuthUserId res : ", res );
                    if(res) {
                        setToastMessage("이미 사용중인 아이디입니다.");
                        setToast(true);
                        return false;
                    } else {
                        setStep(2);
                    }
                })
                .catch( (err) => {
                    console.log( " ====> handleOnConfirm getIsDpAuthUserId error : ", err );
                    setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                    setToast(true);
                })
        }
        if( step >= 4 ) {

            // 수정할것을 감안하여 아이디 부분은 다시 체크한다.
            if( !idRules.lengthAt || !idRules.letterNumberAt ) {
                setToastMessage("아이디 형식이 올바르지 않습니다.");
                setToast(true);
            } else if( idRules.lengthAt && idRules.letterNumberAt ) {
                getIsDpAuthUserId(userIdRef.current.value)
                    .then( (res) => {
                        //console.log( "  ====> handleOnConfirm getIsDpAuthUserId res : ", res );
                        if(res) {
                            setToastMessage("이미 사용중인 아이디입니다. 다시 입력해주세요.");
                            setToast(true);
                            return false;
                        } else {
                            if( pwRules.lengthAt && pswd === rePswd ) { // 보험로직..
                                const signUser = {
                                    ...state
                                    , usrId: userIdRef.current.value, usrPswd: pswd
                                };
                                // 저장처리 로직 작동 ..  1순위 인증서버 저장.. dpAuthSignup 후 uid 담기
                                setDpAuthSignup(signUser)
                                    .then( (res) => {
                                        //const signupRes = res;
                                        //console.log( " ===========> setDpAuthSignup res : ", res );
                                        if( res?.accessToken !== undefined && res?.accessToken !== "" ) {
                                            const jToken = res?.accessToken;
                                            const refreshToken = res?.refreshToken;
                                            const requestLoginUrl = "/signup/saveUser"

                                            const requestOptions = {
                                                headers: {
                                                    Authorization: `Bearer ${jToken}`,
                                                }
                                            }
                                            const signupReq = {
                                                ...signUser, crtfcTknVal: refreshToken,
                                            }
                                            // IITP wellBe서버 저장로직 완료 후 .. =>  MEMBERSHIP_COMPLETE  넘겨준다.
                                            axiosApi.post(requestLoginUrl, signupReq, requestOptions)
                                                .then((res) => {
                                                    //console.log( "=============> iitpUser : ", res );
                                                    if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                                                        const iitpUser = res.data.result.iitpUser;
                                                        sessionStorage.setItem('loginUser', JSON.stringify(iitpUser))
                                                        localStorage.setItem('jToken', jToken);
                                                        setSignUsrInfo( { ...iitpUser });
                                                        // 메뉴설정이 있다면 메뉴 설정 구간...
                                                        //
                                                        // 자동로그인 confirm 후 ok 시 설정팝업
                                                        setIsOpen(true);
                                                    } else if (Number(res.data.resultCode) === Number(CODE.RCV_FAILURE)) {
                                                        // failure // 실패시 ..  두종류가 있음.
                                                        // 1.IITP wellBe 계정이 존재하는 경우(이 경우 나올일이 없지만.. 데이터가 꼬인경우.)
                                                        // 2.IITP wellBe 저장실패
                                                        const isExistUserAt = res.data.result?.isExistAt; // true : 기생성 | false : 저장실패
                                                        if(isExistUserAt) {
                                                            console.log( " ================> RCV_FAILURE : ", res );
                                                            setToastMessage(MSG.ERR_DUPUSR);
                                                            setToast(true);
                                                        } else {
                                                            console.log( " ================> RCV_FAILURE : ", res );
                                                            setToastMessage(MSG.PRCS_FAILSAVE);
                                                            setToast(true);
                                                        }
                                                    } else { // 900 .. 입력 validation 에러
                                                        console.log(" =========> RCV_ERROR_VALIDATION : ", res );
                                                        setToastMessage(MSG.ERR_INPUTVALID);
                                                        setToast(true);
                                                    }
                                                })
                                                .catch((err) => {
                                                    console.log( " ================> RCV_ERROR_SERVER ", err);
                                                })
                                        } else {
                                            setToastMessage(MSG.ERR_PSSUSR+"\n사용자의 "+MSG.ERR_AUTH);
                                            setToast(true);
                                        }

                                    })
                                    .catch( (err) => {
                                        console.log( " ====> handleOnConfirm getIsDpAuthUserId error : ", err );
                                        setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                                        setToast(true);
                                        return false;
                                    })

                            } else {
                                setToastMessage("비밀번호가 조건에 맞지 않거나, 일치하지 않습니다. 다시 확인해주세요.");
                                setToast(true);
                                return false;
                            }
                        }
                    })
                    .catch( (err) => {
                        console.log( " ====> handleOnConfirm getIsDpAuthUserId error : ", err );
                        setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                        setToast(true);
                        return false;
                    })
            }

        }
    };

    /**
     * 인풋박스 텍스트 변경 이벤트 처리
     * @param e
     */
    const handleOnChangeInput = (e) => {

        const inputName = e.target.name;
        //console.log( " ======> input event : ", e.target.name );
        if( inputName === "userId" ) {
            const inputUserId = userIdRef.current;
            if( inputUserId ) {
                // 영문, 숫자만 허용하는 정규식
                inputUserId.value = inputUserId.value.replace(/[^A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]|\s/g, '').trim();
                //console.log( " ========> inputUserId.value : ", inputUserId.value );

                const lengthAt = inputUserId.value.length >= 6 && inputUserId.value.length < 13;
                const letterNumberAt = /[a-zA-Z0-9]/.test(inputUserId.value);

                setIdRules( { lengthAt, letterNumberAt });
            }
        }
        if( ["pswd", "rePswd"].includes(inputName) ) {
            // 정규식 check
            //const regexPw = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,20}$/;
            const regexPw = e.target.value.replace(/[^a-zA-Z0-9~!@#$%^&*()_+|<>?:{}[\]\\;'",./`-]/g, "");

            if (inputName === "pswd") {
                const lengthAt = regexPw.length >= 9;
                const numberAt = /\d/.test(regexPw);
                // const letterLowerAt = /[a-z]/.test(regexPw);
                // const letterUpperAt = /[A-Z]/.test(regexPw);
                const letterAt = /[a-zA-Z]/.test(regexPw);
                const specialAt = /[!@#$%^&*(),.?":{}|<>]/.test(regexPw);

                setPwRules({ lengthAt, numberAt, letterAt, specialAt }); //letterUpperAt
                setPswd(regexPw.trim());
            } else {
                // 비밀번호 재입력은 조건검사 X → 비밀번호 일치 여부만 확인
                setRePswd(regexPw.trim());
            }
        }
    };

    /**
     * Modal Confirm Message 및 자동로그인 셋팅
     * @param chooseAt
     */
    const handleOnComplateAutoLogin = (chooseAt) => {
        if(chooseAt) {
            localStorage.setItem("BREAST_ID", signUsrInfo.usrId);
            localStorage.setItem("BREAST_CRTFC_TKN", signUsrInfo.crtfcTknVal);
            localStorage.setItem("BREAST_SAVE_ID_FLAG", true);
            setIsOpen(false);
            navigate(URL.MEMBERSHIP_COMPLETE, { state : { ...signUsrInfo } });
        } else {
            setIsOpen(false);
            navigate(URL.MEMBERSHIP_COMPLETE, { state : { ...signUsrInfo } });
        }
    };

    useEffect( () => {

        // 비밀번호 → 비밀번호 재입력
        if (step === 2 && Object.values(pwRules).every(Boolean)) {
            setStep(3);
        }

        if (step === 3 && pswd === rePswd && rePswd.length >= 9) {
            setStep(4);
        }

    }, [step, pswd.length, rePswd.length]);

    return (
        <>
            <HeadSub title="회원 가입" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">


                    {/* 아이디 비밀번호 입력 */}
                    <div className={style['content-box']}>
                        <strong className={style['title']}>
                            { step === 1 ?
                                '사용할 아이디를' : '사용할 아이디와 비밀번호를' }<br />
                            입력해주세요</strong>

                        {/* 비밀번호 재입력 */}
                        {step >= 3 && (
                            <div className={style['input-wrap']}>
                                <span className={style['input-tit']}>비밀번호 재입력</span>
                                <div className={style['input-box']}>
                                    <div className={style['pw-box']}>
                                        <input type={rePwView ? "text" : "password"} name="rePswd" placeholder='비밀번호를 입력해주세요'
                                               value={rePswd}
                                               onChange={handleOnChangeInput}
                                        />
                                        <span className={style['line']} data-discord={rePwLineStatus}></span>
                                    </div>
                                    <button className={style['pw-view-btn']} data-view={rePwView ? "on" : "off"} onClick={handleRePwView}>
                                        <span className='blind'>패스워드 on/off</span>
                                    </button>
                                </div>
                                <div className={style['input-bottom']}>
                                    {/* <span>비밀번호를 다시 입력해주세요</span> */}
                                    {
                                        pswd.length < 9 ?
                                            <span className={style['error']}>비밀번호를 9자리 이상 입력해주세요.</span> :
                                            pswd === rePswd ?
                                                <span className={style['on']}>비밀번호가 일치합니다</span>
                                                :
                                                <span className={style['error']}>비밀번호가 일치하지 않습니다</span>
                                    }
                                </div>
                            </div>
                        )
                        }


                        {/* 비밀번호  */}
                        {step >= 2 && (
                            <div className={style['input-wrap']}>
                                <span className={style['input-tit']}>비밀번호</span>
                                <div className={style['input-box']}>
                                    <div className={style['pw-box']}>
                                        <input type={pwView ? "text" : "password"} name="pswd" placeholder='비밀번호를 입력해주세요'
                                               value={pswd}
                                               onChange={handleOnChangeInput}
                                        />
                                        <span className={style['line']} data-discord={pwLineStatus}></span>
                                    </div>
                                    <button className={style['pw-view-btn']} data-view={pwView ? "on" : "off"} onClick={handlePwView}>
                                        <span className='blind'>패스워드 on/off</span>
                                    </button>
                                </div>
                                <div className={style['input-bottom']}>

                                    <span className={style[pwRules.lengthAt ? 'on' : 'off']}>9자리 이상</span>
                                    <span className={style[pwRules.letterAt ? 'on' : 'off']}>영문</span>
                                    {/* <span className={style[pwRules.letterUpperAt ? 'on' : 'off']}>영문대문자</span> */}
                                    <span className={style[pwRules.numberAt ? 'on' : 'off']}>숫자</span>
                                    <span className={style[pwRules.specialAt ? 'on' : 'off']}>특수문자</span>
                                </div>
                            </div>
                        )
                        }


                        {/* 아이디  */}
                        {step >= 1 && (
                            <div className={style['input-wrap']}>
                                <span className={style['input-tit']}>아이디</span>
                                <div className={style['input-box']}>
                                    <input type="text" name="userId" placeholder='아이디를 입력해주세요'
                                           ref={userIdRef}
                                           onChange={handleOnChangeInput}
                                    />
                                    <span className={style['line']}></span>
                                </div>
                                <div className={style['input-bottom']}>
                                    <span className={style[idRules.lengthAt ? 'on' : 'off']}>6-12자 이내</span>
                                    <span className={style[idRules.letterNumberAt ? 'on' : 'off']}>영문(숫자 가능)</span>
                                </div>
                            </div>
                        )
                        }
                    </div>

                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-num="1">
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg"
                                        onClick={() => handleOnConfirm()}
                                        disabled={
                                            step === 1
                                                ? !(idRules.lengthAt && idRules.letterNumberAt)
                                                : step === 2
                                                    ? !(idRules.lengthAt && idRules.letterNumberAt && Object.values(pwRules).every(Boolean))
                                                    : step === 3
                                                        ? !(idRules.lengthAt && idRules.letterNumberAt && Object.values(pwRules).every(Boolean) && pswd === rePswd && rePswd.length >= 9)
                                                        : step >= 4
                                                            ? !(idRules.lengthAt && idRules.letterNumberAt && Object.values(pwRules).every(Boolean) && pswd === rePswd && rePswd.length >= 9)
                                                            : false
                                        }
                                >
                                    <span>확인</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={toastMessage}
                            position='center'
                        />
                    )}

                </div>
            </div>

            <ConfirmBox isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        onCloseCallback={handleOnComplateAutoLogin}
                        message={'가입이 완료되었습니다.\n자동로그인을 설정할까요?'}
                        leftBtnTxt={'아니오'}
                        rightBtnTxt={'네'} />

        </>
    )
}

export default SignUp;
